if (document.querySelector('.image-block-fullscreen-modal')) {
  document.querySelectorAll('.image-block-fullscreen-modal').forEach(modal => {
    modal.addEventListener('show.bs.modal', event => {
      event.target.querySelector('img').attributes['src'].value = event.relatedTarget.attributes['data-full-image'].value;
    })
  });
}